import { UploadStatus } from '@aus-platform/design-system';

export const finishedUploadStatuses: UploadStatus[] = [
  UploadStatus.Completed,
  UploadStatus.Error,
  UploadStatus.Cancelled,
];

export const activeUploadStatuses: UploadStatus[] = [
  UploadStatus.Pending,
  UploadStatus.InProgress,
  UploadStatus.Paused,
  UploadStatus.NetworkError,
];

export const uploadStatusesWithoutPlaybackAction: UploadStatus[] = [
  UploadStatus.Completed,
  UploadStatus.Error,
  UploadStatus.Cancelled,
  UploadStatus.Pending,
];
